const ISO_DATE_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/;

export const toIsoDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const parseIsoDate = (value) => {
  if (!value || typeof value !== "string") return null;
  const match = ISO_DATE_PATTERN.exec(value);
  if (!match) return null;
  const [, year, month, day] = match;
  return new Date(Number(year), Number(month) - 1, Number(day));
};

export const formatIsoDateForDisplay = (value) => {
  if (!value || typeof value !== "string") return "";
  const match = ISO_DATE_PATTERN.exec(value);
  if (!match) return "";
  const [, year, month, day] = match;
  return `${day} - ${month} - ${year}`;
};

export const normalizeBirthDateValue = (birthDateValue) => {
  if (!birthDateValue) return "";

  if (typeof birthDateValue === "string") {
    if (ISO_DATE_PATTERN.test(birthDateValue)) {
      return birthDateValue;
    }

    const queryMatch = birthDateValue.match(
      /year=(\d{4})&month=(\d{1,2})&day=(\d{1,2})/
    );
    if (queryMatch) {
      const [, year, month, day] = queryMatch;
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    }
  }

  if (birthDateValue?.$d instanceof Date && !Number.isNaN(birthDateValue.$d.getTime())) {
    return birthDateValue.$d.toISOString().split("T")[0];
  }

  if (birthDateValue instanceof Date && !Number.isNaN(birthDateValue.getTime())) {
    return birthDateValue.toISOString().split("T")[0];
  }

  return "";
};

